// extracted by mini-css-extract-plugin
export var chip = "_c0-0";
export var filterDropdown = "_c0-5";
export var filterItem = "_c0-6";
export var icon = "_c0-1";
export var removeButton = "_c0-3";
export var removeIcon = "_c0-4";
export var separator = "_c0-2";